module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/1px-278.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/css/1px.md
// module id = 722
// module chunks = 479